import { AxiosClient } from "@/app/shared/services";
import settings from "@/environment";
import { merge } from "lodash";

const state = {
    settings: {
        ...settings,
    },
    isReady: false,
};

const getters = {
    APP_SETTINGS: (state) => state.settings,
    IS_APP_SETTINGS_READY: (state) => state.isReady,
    AGITATION_SETTINGS: (state) => state.settings.agitation,
};

const mutations = {
    SET_APP_SETTINGS: (state, settings) => {
        state.settings = merge(state.settings, settings);
    },
    SET_IS_READY: (state, isReady) => {
        state.isReady = isReady;
    },
};

const actions = {
    GET_APP_SETTINGS: (context) => {
        context.commit("SET_IS_READY", false);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/settings/get")
                .then((data) => {
                    context.commit("SET_APP_SETTINGS", data.data);
                    context.commit("SET_REGISTRATION_STATE", context.getters.APP_SETTINGS);
                    context.commit("SET_IS_READY", true);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {});
        });
    },

    GET_USER_APP_SETTINGS: (context, user) => {
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/settings/user/${user.id}`)
                .then((response) => {
                    context.commit("SET_APP_SETTINGS", response.data);
                    resolve(context.getters.APP_SETTINGS);
                })
                .catch(() => reject());
        });
    },

    GET_GROUP_APP_SETTINGS: (context, group) => {
        return new Promise((resolve, reject) => {
            AxiosClient.get(`settings/group/${group}`)
                .then((response) => {
                    context.commit("SET_APP_SETTINGS", response.data);
                    resolve(context.getters.APP_SETTINGS);
                })
                .catch(() => reject());
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
